import { readable } from "svelte/store";
import { script } from "sbelt/dom";
import { randId } from "sbelt/id";
const GOOGLE_MAPS_API_KEY = "AIzaSyCxTYoLc2kAwV3DqRh_FYi-s1g8WEtbzYg";

type MapsAPI = any;

let _mapsApi: Promise<MapsAPI> | undefined;

export async function mapsApi(): Promise<MapsAPI> {
  if (!_mapsApi) {
    _mapsApi = new Promise<MapsAPI>((resolve) => {
      const cb = "load_maps";
      // Register the callback to google maps api here
      // @ts-ignore
      window[cb] = () => {
        // @ts-ignore
        resolve(window.google.maps);
      };

      script(`//maps.googleapis.com/maps/api/js?libraries=places&key=${GOOGLE_MAPS_API_KEY}&callback=${cb}`);
    });
  }

  return _mapsApi;
}

export async function setupAutocomplete(el: HTMLInputElement, onChange?: (e: any) => void): Promise<() => void> {
  const api = await mapsApi();

  // @ts-ignore
  const ac = new api.places.Autocomplete(el);

  const l = api.event.addListener(ac, "place_changed", onChange || (() => {}));

  return () => api.event.removeListener(l);
}
